<template>
    <div class="bannerBox">
        <video autoplay loop muted
            poster="https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/photo-1482245294234-b3f2f8d5f1a4.jpg"
            class="bgvid" id="bgvid">
            <source src="https://lanjingshuziguanwang-public.oss-accelerate.aliyuncs.com/video/video.mp4"
                type="video/mp4">
        </video>
        <!-- <div class="bannnerimg"></div> -->
        <div class="video-shake">
            <div class="logoTitle">
                <div class="logo" :class='{isShow:logoShow}'></div>
            </div>
            <p class="center">{{center}}</p>
            <i class="iconfont icon-jiantou1"></i>
        </div>
        <!-- </parallax> -->
    </div>
</template>
<script>
    // import Parallax from 'vue-parallaxy'
    export default {
        name: 'Banner',
        components: {
            // Parallax
        },
        data() {
            return {
                logoShow: false,
                center: '致力于成为一家在外贸领域和社交网络时代为企业提供全网营销的数字营销公司'
            }
        },
        methods: {
            showLogo() {
                this.logoShow = true
            }
        }
    }
</script>
<style scoped>
    @import url('../../../font/ifont/iconfont.css');

    .bannerBox {
        width: 100%;
        height: 100vh;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/photo-1482245294234-b3f2f8d5f1a4.jpg') no-repeat center;
        background-size: cover;
        overflow: hidden;
        position: relative;

    }

    .bannnerimg {
        width: 100%;
        height: 100%;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E7%BB%84%20749.jpg') no-repeat center;
        background-size: cover;
    }

    .bgvid {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .video-shake {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* background-color: rgba(0, 0, 0, .3); */
        background-color: transparent;
    }

    .video-shake .iconfont {
        font-size: 24px;
        color: #ffffff;
        position: absolute;
        left: 50%;
        bottom: 50px;
        transform: translateX(-50%);
        transform: rotate(90deg);
        animation: downD 6s ease-in-out infinite;
    }

    .center {
        font-size: 30Px;
        font-weight: 300;
        line-height: 140%;
        color: rgba(255, 255, 255, 1);
        max-width: 580Px;
        text-align: center;
        margin-top: 38px;
    }

    .logoTitle {
        width: 766px;
        height: 183px;
        overflow: hidden;
        position: relative;
    }

    .logo {
        width: 100%;
        height: 100%;
        background: url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/%E8%93%9D%E9%B2%B8LOGO.png') no-repeat center;
        background-size: 80%;
        position: absolute;
        top: 100%;
        transition: all 1.5s ease-in-out;
    }

    .isShow {
        top: 0;
    }

    @keyframes downD {
        0% {
            bottom: 50px;
        }

        10% {
            bottom: 50px;
        }

        20% {
            bottom: 50px;
        }

        30% {
            bottom: 50px;
        }

        40% {
            bottom: 30px;
        }

        50% {
            bottom: 50px;
        }

        75% {
            bottom: 30px;
        }

        100% {
            bottom: 50px;
        }
    }

    @media(max-width: 995px) {
        .logoTitle {
            width: 80%;
        }

        .center {
            font-size: 24px;
            max-width: 80%;
            text-align: center;
            margin-top: 1%;
        }

        .bgvid {
        display: none;
    }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/home/banner.vue